import React, { lazy, useState, useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  MainContainer,
  RecogntionTopCard
} from "../Recognition/CompanyAnalytics/styles";
import { ImageUrl } from "../../utils/constants";
import { commaSeperator, generateDummyData } from "../../utils/methods";
import {
  TopChallengesWrapper,
} from "../CompanyEvents/styles";
const TopDataGraph = lazy(() => import('../common/Analytics/TopThreeDataGraph'));
import { Table } from '../common/commonStyles';
import {Heading, ScrollableContainer, ViewMore} from '../RecogntionAdmin/styles'
// import BarChart from '../common/Manager/BarChart';
import MonthlyBarChart from "../common/Manager/MonthlyChart/MonthlyBarChart";
import {/*FitnessDeviceCard, */WeeksMain, KeyInsightWrapper, InsightCard, SeeMoreButton, NochallengeCard} from './style'
import {/*AnalyticsIcon,*/ ThemeChallenge, RecognitionUpArrow, EmojiModerate, EmojiGood, EmojiHappy, AdminInsightsIcon, StarIcon, AdminDownloadIcon, ChallengeIcon, RecognitionEyeIcon} from '../../utils/icons'
import VerticalBarChart from './verticalbar'
import {BarChartContainer, Border} from '../common/Manager/style'
import CompletechallengeCard from './completeChallenge'
import {GetAdminActiveandUpcomingChallenges} from '../../redux/constants/apiConstants'
import { fetchApi, getInitials } from "../../utils/methods";
import { toggleDummyChallenges } from "../../redux/actions";
import {CardWrapper} from './style'
import {CommonFilterDropdown} from '../common/CommonDropDown/CommonDropdownForFilters'
import CSVList from "../AttendeesModal/CSVList";
import {CommonButton} from '../common/commonStyles'
import { NameInitials } from "../Manager/styles";

const CompanyAnalytics = ({companyid, adminChallengeOverviewData, activityChallengeData, behaviorChallengeData, challengeTopParticpantsData, challengeTopLeadersData, history, snapShotData, selectedOption, user}) => {
  const [showEliteRecogntion, setShowEliteRecogntion] = useState(false);
  const [showTopRecogntion, setShowTopRecogntion] = useState(false);
  const [showEliteCelebration, setShowEliteCelebration] = useState(false);
  const [showTopCelebration, setShowTopCelebration] = useState(false);
  const [challengesData, setChallengesData]= useState([]);
  const [challengesDataLoading, setChallengesDataLoading]= useState(false);
  const [onHover, onEnterMouse]= useState(null)
  // const [selectedActivity, setSelectedActivity]= useState(null)
  const [selectedTheme, setSelectedTheme]= useState("Daily")
  const [showActivity, setActivity]= useState(false)
  const [showWellness, setWellness]= useState(false)
  const [topChallengetype, setTopChallengetype]= useState(1)
  const [printParticipantCSV,setPrintParticipantCSV]=useState(false)
  const [updatedPartcipantCSV, setUpdatedPartcipantCSV]=useState([])
  const [showAllCompany, setShowAllCompany]=useState(false)

  const onEnterHover=(id)=>{
    onEnterMouse(id)
  }

  const onLeaveMouse=()=>{
    onEnterMouse(-1)
  }

  const fetchSynchrisemployees = async () => {
    try {
      const response = await fetchApi(`${GetAdminActiveandUpcomingChallenges}/${companyid}`, "GET");
      if (response?.message) {
        // toast.error(res.message);
      }
      else {
        setChallengesDataLoading(true)
        setChallengesData(response?.data?.active_challenges)
      }
    } catch (error) {
      // toast.error(error.message);
    }
  };

  useEffect(()=>{
    fetchSynchrisemployees()
  },[])

  const topDepartment = () => {
    const dataArray = [
      { name: 'Sales', color: '#FFF', value: 70, width: 204, background: '#92A4DA' },
      { name: 'Product', color: '#FFF', value: 40, width: 160, background: '#BE7D9C' },
      { name: 'Tech', color: '#FFF', value: 20, width: 96, background: '#75B084' },
    ];
    return (
      <TopDataGraph data={dataArray} heading={'Top Performing Departments'} total={807} totalSubText='Total Challenges' />
    );
  };

  const topLocation = () => {
    const dataArray = [
      { name: 'Pune', color: '#FFF', value: 70, width: 204, background: '#DA92C8' },
      { name: 'New York', color: '#FFF', value: 40, width: 160, background: '#B1AA56' },
      { name: 'Mumbai', color: '#FFF', value: 20, width: 96, background: '#DA6C74' },
    ];
    return (
      <TopDataGraph data={dataArray} heading={'Top Performing Locations'} total={607} totalSubText='Total Challenges' />
    );
  };

  const showRecognitionDetails = () => {
    const EngagementEmployeeData = [
      {
        title: "Total Challenges Launched",
        value: "1",
        img: "/admin-challenge/challenge-launch.svg",
        text: "posted",
        color: "rgba(133, 192, 234, 1)",
        total: 100,
        imageBackground: "#BE7D9C",
        subText: "Posts",
        info: "",
        average:
          37 +" Users participated out of "+ 87,
      },
      {
        title: "Completed Activity Challenges",
        titleNew: "",
        value: "2",
        img: "/admin-challenge/actiity.svg",
        text: "received recognition",
        color: "rgba(220, 148, 181, 1)",
        total: 70,
        average:"",
        imageBackground: "#91C49D",
        subText: "People Received",
        info: "",
      },
      {
        title: "Completed Wellness Challenges",
        value: "3",
        img: "/admin-challenge/wellness.svg",
        text: "gave recognition",
        color: "rgba(118, 171, 120, 1)",
        total: 80,
        average: "",
        imageBackground: "#B1AA56",
        subText: "People Gave",
        info: "",
      },
      {
        title: "Goals Completed",
        titleNew: "Value",
        value: "4",
        img: "/admin-challenge/goal.svg",
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: 707,
        average: "Avg 38 goals per users",
        imageBackground: "#DA92C8",
        subText: "People Exemplified",
        info: "",
      },
      {
        title: "Company's Steps",
        titleNew: "Value",
        value: "5",
        img: "/admin-challenge/step.svg",
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: 707,
        average:"Avg 389,064.0 steps per users",
        imageBackground: "#92A4DA",
        subText: "People Exemplified",
        info: "",
      },
      {
        title: "Company's Workouts",
        titleNew: "Value",
        value: "6",
        img: "/admin-challenge/workout.svg",
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: 707,
        average:"",
        imageBackground: "#BE7D9C",
        subText: "People Exemplified",
        info: "",
      },
      {
        title: "Company's Distance Covered",
        titleNew: "Value",
        value: "7",
        img: "/admin-challenge/distance-covered.svg",
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: 707,
        average:"",
        imageBackground: "#DA6C74",
        subText: "People Exemplified",
        info: "",
      },
      {
        title: "Company's Total Time",
        titleNew: "Value",
        value: "8",
        img: "/admin-challenge/total-time.svg",
        text: "received value",
        color: "rgba(175, 135, 193, 1)",
        total: "22H 20M",
        average:"Avg 38 mins steps per users",
        imageBackground: "#DA9B6C",
        subText: "People Exemplified",
        info: "",
      },
    ];
    return EngagementEmployeeData.map((details, index) => (
      <RecogntionTopCard key={index} background={details.imageBackground}>
        <div className="image">
          <img src={ImageUrl + details.img} />
        </div>
        <div className="title">{details.title}</div>
        <div className="value">{(details?.total)}</div>
        <div className="percent-user">{details.average}</div>
      </RecogntionTopCard>
    ));
  };

  const formatNumberToK=(input)=> {
    // Remove commas and convert to number
    const number = Number(input.toString().replace(/,/g, ''));
  
    if (isNaN(number)) return 'Invalid number';
  
    if (number >= 1_000_000_000) {
      return (number / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + 'B';
    } else if (number >= 1_000_000) {
      return (number / 1_000_000).toFixed(1).replace(/\.0$/, '') + 'M';
    } else if (number >= 1_000) {
      return (number / 1_000).toFixed(1).replace(/\.0$/, '') + 'K';
    } else {
      return number.toString();
    }
  }

  const showTopCards = (overviewDetails) => {
    const EngagementEmployeeData = [
      {
        title: "Challenge Engagement",
        value: "1",
        img: "/admin-challenge/engagement.png",
        total: overviewDetails.challenge_engagement_percentage+"%",
        imageBackground: "#BE7D9C",
        average:overviewDetails.challenge_engagement_count +" Users participated out of "+ overviewDetails.user_enrolled_count,
      },
      {
        title: "Total Challenge Completed",
        value: "2",
        img: "/admin-challenge/actiity.svg",
        total: commaSeperator(overviewDetails.total_challenge_completed),
        average:/*"Avg "+ overviewDetails?.total_challenge_average.toFixed(1) +" challenge completed per users",*/"",
        imageBackground: "#75B084",
      },
      {
        title: "Wellness Challenge Activities",
        value: "3",
        img: "/admin-challenge/wellness.svg",
        total: commaSeperator(overviewDetails.behavior_challenge_count),
        average: /*"Avg "+ overviewDetails?.behavior_challenge_percentage.toFixed(1) +" activities per user",*/"",
        imageBackground: "#B1AA56"
      },
      {
        title: "Company's Steps",
        value: "4",
        img: "/admin-challenge/step.svg",
        total: formatNumberToK(commaSeperator(overviewDetails.total_steps_company)),
        average: "Avg "+ commaSeperator(overviewDetails.average_total_steps.toFixed(1)) +" steps per users",
        imageBackground: "#92A4DA",
      }  
    ];
    return EngagementEmployeeData.map((details, index) => (
      <RecogntionTopCard key={index} background={details.imageBackground}>
        <div className="image">
          <img src={ImageUrl + details.img} />
        </div>
        <div className="title">{details.title}</div>
        <div className="value">{(details?.total)}</div>
        <div className="percent-user">{details.average}</div>
      </RecogntionTopCard>
    ));
  };

  const topdepartment = [
    { name: 'Element 1', value: 70, image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FFF3ED" },
    { name: 'Element 2', value: 60 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FFF3ED"},
    { name: 'Element 3', value: 50 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#F0F7FF"},
    { name: 'Element 4', value: 40 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FEF2F3"},
    { name: 'Element 5', value: 30 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#F0F7FF"},
    { name: 'Element 6', value: 20 , image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FEF2F3"},
    { name: 'Element 7', value: 70, image:"https://ddf0gygzuiev4.cloudfront.net/profile-Image/Avatars/Avatar-5.png", color:"#FFF3ED" },
  ];

  const toggleShowEliteRecognition = (value) => {
    if(value=="celebration"){
      setShowEliteCelebration(!showEliteCelebration)
    }
    else{
      setShowEliteRecogntion(!showEliteRecogntion);
    }
  };

  const toggleShowTopRecognition = (value) => {
    if(value=="celebration"){
      setShowTopCelebration(!showTopCelebration)
    }
    else{
      setShowTopRecogntion(!showTopRecogntion)
    }
  };

  const bestPerformer = (value)=>{
    const displayedTopDepartments = showTopRecogntion ? generateDummyData(12) : generateDummyData(12).slice(0, 5);

    const displayedEliteDepartments = showEliteRecogntion ? generateDummyData(12) : generateDummyData(12).slice(0, 5);
    return(
      <>
        <div className='top-performing' style={{display:"block"}} >
          <Table padding="8px 0" insight>
            <div className="heading">October | Monthly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total Challenges</div>
              </div>
            )}
            <ScrollableContainer
              height={showTopRecogntion ? "380px" : "330px"}
              showAllRows={showTopRecogntion}
            >
              {displayedTopDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="profile">
                    <img src={ImageUrl + "/" + data.image} alt={data.name} />
                  </div>
                  <div className="name">{data.name}</div>
                  <div className="value">{data.value}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showTopRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowTopRecognition}>
                  Show More
                </div>
              </div>
            )}
          </Table>

        </div>
        <div className='low-performing' style={{display:"block"}}>
          <Table padding="8px 0" insight>
            <div className="heading">October-December | Quarterly</div>
            {value !== "celebration" && (
              <div className="type">
                <div className="name">Employees</div>
                <div className="value">Total Challenges</div>
              </div>
            )}
            <ScrollableContainer
              height={showEliteRecogntion ? "380px" : "330px"}
              showAllRows={showEliteRecogntion}
            >
              {displayedEliteDepartments.map((data, index) => (
                <div className="item" key={index}>
                  <div className="profile">
                    <img src={ImageUrl + "/" +data.image} alt={data.name} />
                  </div>
                  <div className="name">{data.name}</div>
                  <div className="value">{data.value}</div>
                </div>
              ))}
            </ScrollableContainer>
            {topdepartment.length > 5 && !showEliteRecogntion && (
              <div className="showmore">
                <div className="button" onClick={toggleShowEliteRecognition}>
                  Show More
                </div>
              </div>
            )}
           
          </Table>

        </div>
      </>
    )
  }

  // const healthData = [
  //   { name: "Apple Health", value: 250, color: "#DA6C74" },
  //   { name: "Apple Watch", value: 180, color: "#DA9B6C" },
  //   { name: "Google Fit", value: 120, color: "#DA9B6C" },
  //   { name: "Fitbit", value: 100, color: "#DA92C8" },
  //   { name: "Garmin", value: 30, color: "#92A4DA" },
  //   { name: "Others", value: 20, color: "#75B084" }
  // ];

  const sampleData = [
    { "label": "Jan", "value": 30 },
    { "label": "", "value": 50 },
    { "label": "", "value": 80 },
    { "label": "", "value": 40 },
    { "label": "", "value": 60 },
    { "label": "", "value": 70 },
    { "label": "", "value": 90 },
    { "label": "Feb", "value": 50 },
    { "label": "", "value": 20 },
    { "label": "", "value": 40 },
    { "label": "", "value": 30 },
    { "label": "", "value": 60 },
    { "label": "", "value": 75 },
    { "label": "", "value": 85 },
    { "label": "Mar", "value": 80 },
    { "label": "", "value": 55 },
    { "label": "", "value": 65 },
    { "label": "", "value": 45 },
    { "label": "", "value": 35 },
    { "label": "", "value": 50 },
    { "label": "", "value": 70 },
    { "label": "Apr", "value": 40 },
    { "label": "", "value": 30 },
    { "label": "", "value": 90 },
    { "label": "", "value": 55 },
    { "label": "", "value": 65 },
    { "label": "", "value": 75 },
    { "label": "", "value": 85 },
    { "label": "May", "value": 60 },
    { "label": "", "value": 40 }
  ]

  // const options = [
  //   "Monthly","Quarterly","Yearly"
  // ]

  const activity = [
    "Daily","Monthly"
  ]

  const dailyCard = () => (
    <>
      <Heading>
        <div className='icon'>
          <ThemeChallenge/>
        </div>
        Monthly Theme Challenges
        <div className="dropdown">
          <CommonFilterDropdown
            options={activity}
            selectedOption={selectedTheme}
            setSelectedOption={setSelectedTheme}
            dropdownHeight={"auto"}
          />
        </div>
      </Heading>
      <BarChartContainer>
        <div className='heading'>Employees Activity Summary</div>
        <Border/>
        <div className='total-row'>
          <span className='total'>{500}</span>
          <span className='total-text'>Responses</span>
          <span className="border"/>
          <span className="emoji-users">
            <div className="emoji"><EmojiModerate/></div>
            <div className="help">Helped a Bit</div>
            <div className="user">50 Users</div>
          </span>
          <span className="emoji-users">
            <div className="emoji"><EmojiGood/></div>
            <div className="help">Great and Useful</div>
            <div className="user">50 Users</div>
          </span>
          <span className="emoji-users">
            <div className="emoji"><EmojiHappy/></div>
            <div className="help">Made My Day!</div>
            <div className="user">50 Users</div>
          </span>
        </div>
        <div className='compare-row'>
          <div className='stat'><span className='icon'>{RecognitionUpArrow()}</span>{50} % </div>
          <div className='text'>{" vs last month"}</div>
        </div>
      </BarChartContainer>
      <VerticalBarChart data={sampleData } width={400} height={250}/>
      <WeeksMain>
        <div className="week">Jan 1</div>
        <div className="week">Jan 8</div>
        <div className="week">Jan 15</div>
        <div className="week">Jan 22</div>
        <div className="week">Jan 28</div>
      </WeeksMain>
    </>
  )

  const monthlyCard = () => (
    <>
      <Heading>
        <div className='icon'>
          <ThemeChallenge/>
        </div>
        Monthly Theme Challenges
        <div className="dropdown">
          <CommonFilterDropdown
            options={activity}
            selectedOption={selectedTheme}
            setSelectedOption={setSelectedTheme}
            dropdownHeight={"auto"}
          />
        </div>
      </Heading>
      <div style={{marginTop:"20px"}}><MonthlyBarChart id="monthly" total="12" heading="Monthly Breakdown" totalText="Total Challenges" barColor="#C5C37F" barColorActive="#A49A4E" type="monthly-theme"/></div>
    </>
  )

  const keyInsight = () => (
    <>
      <Heading isMargin={"20px 0px 20px 0px"}>
        <div className='icon'>
          {AdminInsightsIcon()}
        </div>
          Key Insights
      </Heading>
      <KeyInsightWrapper>
        <div className='divSize' >
          <InsightCard padding="8px 0" insight isMinHeight="424px" background="#91C49D">
            <div className="header">
              <div className="icon">
                <img src={ImageUrl+"/"+"admin-challenge/actiity.svg"}/>
              </div>
              <div className="text">Activity Challenge Completed</div>
            </div>
            <div
              className="wrapper"
            >  
              <div className="line"/>
              <div className="card-insight" >
                <div className="title">4+ completed</div>
                <div className="value">{activityChallengeData?.four_plus}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">3 completed</div>
                <div className="value">{activityChallengeData?.three}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">2 completed</div>
                <div className="value">{activityChallengeData?.two}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">1 completed</div>
                <div className="value">{activityChallengeData?.one}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">0 completed</div>
                <div className="value">{activityChallengeData?.zero}%</div>
              </div>
            </div>
          </InsightCard>
        </div>
        <div className='divSize'>
          <InsightCard padding="8px 0" insight isMinHeight="424px" background="#B1AA56">
            <div className="header">
              <div className="icon">
                <img src={ImageUrl+"/"+"admin-challenge/well.svg"}/>
              </div>
              <div className="text">Behaviour Challenge Completed </div>
            </div>
            <div
              className="wrapper"
            >  
              <div className="line"/>
              <div className="card-insight" >
                <div className="title">4+ completed</div>
                <div className="value">{behaviorChallengeData?.four_plus}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">3 completed</div>
                <div className="value">{behaviorChallengeData?.three}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">2 completed</div>
                <div className="value">{behaviorChallengeData?.two}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">1 completed</div>
                <div className="value">{behaviorChallengeData?.one}%</div>
              </div>
              <div className="line"/>
              <div className="card-insight">
                <div className="title">0 completed</div>
                <div className="value">{behaviorChallengeData?.zero}%</div>
              </div>
            </div>
          </InsightCard>
        </div>
        <div className='divSize'>
          <InsightCard>
            <div className="wrapper">
              <div className="no-data">
                <img src={ImageUrl+"/admin-challenge/comingsoon.svg"}/>
                <div className="comingSoon">Coming Soon!</div>
              </div>
            </div>
          </InsightCard>
        </div>
      </KeyInsightWrapper>
    </>
  )

  const printActionLedaers = (bool, value) => {
    setTopChallengetype(value)
    if(value===2){
      printActionLeader(bool);
    }else{
      printAction(bool);
    }
  }

  const printAction = (bool) => {
    let updatedPartcipantCSV = challengeTopParticpantsData && challengeTopParticpantsData.length > 0 &&
      challengeTopParticpantsData.map((particpants) => {
        let obj = {};
        obj['NAME'] = particpants['name'];
        obj['EMAIL'] = particpants['mail'];
        obj['DEPARTMENT'] = particpants['department'];
        obj['LOCATION'] = particpants['location'];
        obj['TEAM NAME'] = particpants['team_name'];
        obj['ACTIVITY CHALLENGE COUNT'] = particpants['activity_challenge_count'];
        obj['BEHAVIOR CHALLENGE COUNT'] = particpants['behavior_challenge_count'];
        obj['TOTAL CHALLENGE COUNT'] = particpants['total_challenge_count'];
        return obj;
      })
    setPrintParticipantCSV(bool)
    setUpdatedPartcipantCSV(updatedPartcipantCSV)
  };

  const printActionLeader = (bool) => {
    let topLeaderboard = [];
    if (challengeTopLeadersData?.length && challengeTopLeadersData) {
      topLeaderboard = challengeTopLeadersData[0];
    }
    let updatedPartcipantCSV = topLeaderboard && topLeaderboard.length > 0 &&
      topLeaderboard.map((leaders) => {
        let obj = {};
        obj['NAME'] = leaders['name'];
        obj['EMAIL'] = leaders['mail'];
        obj['ACTIVITY CHALLENGE POINTS'] = leaders['activity_points'];
        obj['BEHAVIOR CHALLENGE POINTS'] = leaders['behavior_points'];
        obj['TOTAL CHALLENGE POINTS'] = leaders['total_points'];
        return obj;
      })
    setPrintParticipantCSV(bool)
    setUpdatedPartcipantCSV(updatedPartcipantCSV)
  };

  const spotlight = () => {
    let topLeaderboard=[];
    if ( challengeTopLeadersData?.length && challengeTopLeadersData) {
      topLeaderboard = challengeTopLeadersData[0];
    }
    const fileTitle = topChallengetype === 1 ? "Challenge Participants" : "Challenge Leaders";
    const csvHeaders = topChallengetype === 1 ?
      [
        { label: "Name", key: "NAME" },
        { label: "Email", key: "EMAIL" },
        { label: "Department", key: "DEPARTMENT" },
        { label: "Location", key: "LOCATION" },
        { label: "Team", key: "TEAM NAME" },
        { label: "Activity Challenge Count", key: "ACTIVITY CHALLENGE COUNT" },
        { label: "Behavior Challenge Count", key: "BEHAVIOR CHALLENGE COUNT" },
        { label: "Total Challenge Count", key: "TOTAL CHALLENGE COUNT" },
      ] :
      [
        { label: "Name", key: "NAME" },
        { label: "Email", key: "EMAIL" },
        { label: "Activity Challenge Points", key: "ACTIVITY CHALLENGE POINTS" },
        { label: "Behavior Challenge Points", key: "BEHAVIOR CHALLENGE POINTS" },
        { label: "Total Challenge Points", key: "TOTAL CHALLENGE POINTS" },
      ]
    return(<>
      <Heading isMargin={"20px 0px 20px 0px"}>
        <div className='icon'>
          {StarIcon()}
        </div>
          Spotlight
      </Heading>
      <KeyInsightWrapper>
        <div className='divSpotlight' >
          <InsightCard margin="0" insight height={showActivity?'308px':"310px"} padding={showActivity?"5px":"0"} direction={showActivity?"none":"column"} background="#91C49D" showAllRows={showActivity}>
            <div className="header">
              <div className="text">Top Challenge Participants</div>
              <div className="endDiv" onClick={() => printActionLedaers(true, 1)}>{AdminDownloadIcon()}</div>
            </div>
            <div className="border-top"/>
            <div className="headers-title">
              <div className="name">Name</div>
              <div className="activity">Activity</div>
              <div className="wellness">Behaviour</div>
              <div className="total">Total</div>
            </div>
            <div
              className="wrapper"
            >  
              {challengeTopParticpantsData?.length===0?<div className="no-data">No Data Found</div>: challengeTopParticpantsData?.map((data,index)=>(
                <>
                  <div className="card-spotlight" key={index}>
                    {data?.profile_image !== "profile-Image/default.png"?<div className="profile">
                      <img src={ImageUrl+"/"+data?.profile_image}/>
                    </div>:<NameInitials id="name-initials" margin="0 8px 0 0">{getInitials(data?.name)}</NameInitials> }
                    <div className="name">{data?.name}</div>
                    <div className="activity">{data?.activity_challenge_count}</div>
                    <div className="behavior">{data?.behavior_challenge_count}</div>
                    <div className="total">{data?.total_challenge_count}</div>
                  </div>
                  {challengeTopParticpantsData?.length>(index+1)&&<div className="border"/>}
                </>))}
            </div>
            {challengeTopParticpantsData?.length>5&&!showActivity&&<SeeMoreButton onClick={()=>setActivity(true)}>
              See More
            </SeeMoreButton>}
          </InsightCard>
        </div>
        <div className='divSpotlight'>
          <InsightCard margin="0" insight height={showWellness?'307px':"310px"} padding={showWellness?"5px":"0"} direction={showWellness?"none":"column"} background="#91C49D" showAllRows={showWellness}>
            <div className="header">
              <div className="text">Top Challenge Leaders</div>
              <div className="endDiv" onClick={() => printActionLedaers(true, 2)}>{AdminDownloadIcon()}</div>
            </div>
            <div className="border-top"/>
            <div className="headers-title">
              <div className="name">Name</div>
              <div className="activity">Activity Pts.</div>
              <div className="wellness">Behaviour Pts.</div>
              <div className="total">Total Pts.</div>
            </div>
            <div
              className="wrapper"
            >  
              {topLeaderboard?.length===0?<div className="no-data">No Data Found</div>:topLeaderboard?.map((data,index)=>(
                <>
                  <div className="card-spotlight" key={index}>
                    {data?.profile_image !== "profile-Image/default.png"?<div className="profile">
                      <img src={ImageUrl+"/"+data?.profile_image}/>
                    </div>:<NameInitials id="name-initials" margin="0 8px 0 0">{getInitials(data?.name)}</NameInitials> }
                    <div className="name">{data?.name}</div>
                    <div className="activity">{data?.activity_points}</div>
                    <div className="behavior">{data?.behavior_points}</div>
                    <div className="total">{data?.total_points}</div>
                  </div>
                  {topLeaderboard?.length>(index+1)&&<div className="border"/>}
                </>))}
            </div>
            {topLeaderboard?.length>5&&!showWellness&&<SeeMoreButton onClick={()=>setWellness(true)}>
              See More
            </SeeMoreButton>}
          </InsightCard>
        </div>
      </KeyInsightWrapper>
      {printParticipantCSV && topChallengetype === 1 && updatedPartcipantCSV ? printParticipantCSV && <CSVList Title={fileTitle} removeCSVData={printAction} headers={csvHeaders} data={updatedPartcipantCSV} /> : topChallengetype === 2 && updatedPartcipantCSV && printParticipantCSV && <CSVList Title={fileTitle} removeCSVData={printActionLeader} headers={csvHeaders} data={updatedPartcipantCSV} />}
    </>)
  }

  const activeChallenge = (data) => {
    let challengesData= showAllCompany?data:data?.slice(0,3)
    return(<>
      <Heading isMargin={"20px 0px 20px 0px"}>
        <div className='icon'>
          {ChallengeIcon()}
        </div>
        Active Challenges
        {data?.length>3&&!showAllCompany&&<div className="dropdown">
          <ViewMore onClick={()=>setShowAllCompany(true)}>
            {RecognitionEyeIcon("#F37A65")}
            <div className="view">View All</div>
          </ViewMore>
        </div>}
      </Heading>
      <CardWrapper>
        {challengesData?.length > 0 && challengesData.map((challenge, index) => (
          <CompletechallengeCard
            challenge={challenge}
            history={history}
            key={index}
            toggleDummyChallenges={toggleDummyChallenges}
            margin={index}
            adminChallenge={'1'}
            onEnterMouse={onEnterHover}
            onLeaveMouse={onLeaveMouse}
            onHover={onHover}
            adminDashboard={1}
          />
        ))}
      </CardWrapper>
    </>)
  }
  let currentYear = new Date().getFullYear();
  const hideShowCustomizeCard=selectedOption===currentYear;
  return (
    <>
      <MainContainer margin>
        <TopChallengesWrapper margin="0 0 0px 0" gap="20px">
          {companyid===18?showRecognitionDetails():showTopCards(adminChallengeOverviewData)}
        </TopChallengesWrapper>
        {challengesData?.length>0?activeChallenge(challengesData):hideShowCustomizeCard&&challengesDataLoading&&<NochallengeCard>
          <div className="image">
            <img src={ImageUrl+"/images/AdminReports/demo.svg"}/>
          </div>
          <div className="details">
            <div className="title">Launch Challenge</div>
            <div className="subtext">Hey {user?.fname}, Your Company does not have any Active Company Challenges. Launch a company challenge today for your <br/> employees!</div>
            <div className="button">
              <CommonButton onClick={()=>history.push('/company/challenges/categories')}>Launch a Challenge</CommonButton>
            </div>
          </div>
        </NochallengeCard>}
        {keyInsight()}
        {spotlight()}
        {/* <Heading>
          <div className='icon'>
            <img src={ImageUrl + "/admin-recognition/top-performer.svg"} />
          </div>
          Best Performers
        </Heading>
        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          {bestPerformer()}
        </div>
        <div className="main-top-low-card" style={{marginTop:"20px"}}>
          <div className='top-performing'>{topDepartment()}</div>
          <div className='top-performing'>{topLocation()}</div>
        </div>
        <Heading>
          <div className='icon'>
            <AnalyticsIcon/>
          </div>
          Company Analytics
          <div className="dropdown">
            <CommonFilterDropdown
              options={options}
              selectedOption={selectedActivity}
              setSelectedOption={setSelectedActivity}
              dropdownHeight={"auto"}
            />
          </div>
        </Heading>
        <div style={{marginTop:"20px"}}><MonthlyBarChart id="activity" total="148.1M" heading="Employees Activity Summary" totalText="Miles" barColor="#CE98B3" barColorActive="#A65C7C" showCategory/></div>
        <div className="main-top-low-card" style={{margin:"20px 0px"}}>
          <div className='top-performing' style={{display:"block"}} >
            <BarChart heading="Top 5 Wellness Goal" data={generateDummyData(5)} id={1} total={460} barColor={"#B9C8E8"} circleColor={"#B9C8E8"} circleBorderColor={"#D3DEF2"} totalText="Total Challenges"/>
          </div>
          <div className='low-performing' style={{display:"block"}} >
            <BarChart total="260" heading="Top 5 Workout Interests" data={generateDummyData(5)} id={2} barColor={"#E3B78E"} circleColor={"#E3B78E"} circleBorderColor={"#EED5BA"} totalText="Total Challenges"/>
          </div>
        </div>
        <Heading>
          <div className='icon'>
            <img src={ImageUrl + "/admin-recognition/top-performer.svg"} />
          </div>
          Active Challenge
        </Heading>
        {
          <CardWrapper>
            {challengesData?.length > 0 && challengesData.map((challenge, index) => (
              <CompletechallengeCard
                challenge={challenge}
                history={history}
                key={index}
                toggleDummyChallenges={toggleDummyChallenges}
                margin={index}
                adminChallenge={'1'}
                onEnterMouse={onEnterHover}
                onLeaveMouse={onLeaveMouse}
                onHover={onHover}
              />
            ))}
          </CardWrapper>}
        {selectedTheme==="Daily"?dailyCard():monthlyCard()}
        <FitnessDeviceCard >
          <div className="heading">Top 5 Fitness Devices</div>
          <div className="details">
            <div className="title">700
              <div className="subtitle">Devices Connected</div>
            </div>
            <div className="wrap-card">
              <div className="device">
                {healthData.map((data, index)=>
                  <div className="device-name" key={index}>
                    <div className="circle" style={{background:data?.color}}/>
                    <div className="count">{data.name}&nbsp;{data.value}</div>
                  </div>)}
              </div>
              <div className="device-images">
                <div className="fitbit">
                  <img src={ImageUrl + "/admin-challenge/fitbit.svg"} />
                </div>
                <div className="health">
                  <img src={ImageUrl + "/admin-challenge/health.svg"} />
                </div>
                <div className="garmin">
                  <img src={ImageUrl + "/admin-challenge/garmin.svg"} />
                </div>
                <div className="googlefit">
                  <img src={ImageUrl + "/admin-challenge/google-fit.svg"} />
                </div>
                <div className="applewatch">
                  <img src={ImageUrl + "/admin-challenge/applewatch.svg"} />
                </div>
              </div>
            </div>
          </div>  
        </FitnessDeviceCard>   */}
      </MainContainer>
      <div style={{marginTop:"20px"}}><MonthlyBarChart total={snapShotData?.total_challenges}  heading="Monthly Breakdown" totalText="Total Challenges" barColor="#CE98B3" barColorActive="#A65C7C" dataGraph={snapShotData?.monthly_breakdown} totalPercentage={snapShotData?.monthly_growth > 0 ? snapShotData?.monthly_growth : 0 }/></div>
      {selectedTheme==="test"&&<>
        {bestPerformer()}
        {dailyCard()}
        {monthlyCard()}
        {topDepartment()}
        {topLocation()}
      </>}
    </>
  );
};

CompanyAnalytics.propTypes = {
  selectedYearInfo: PropTypes.number,
  history: PropTypes.object,
  companyid: PropTypes.number,
  toggleDummyChallenges: PropTypes.func,
  challengeTopLeadersData: PropTypes.array,
  challengeTopParticpantsData: PropTypes.array,
  challengeOverviewData: PropTypes.array,
  employeeCount: PropTypes.number,
  activityChallengeData: PropTypes.array,
  behaviorChallengeData: PropTypes.array,
  user: PropTypes.object,
  topChallenges: PropTypes.array,
  adminChallengeOverviewData: PropTypes.array,
  hideShowChallenge: PropTypes.func,
  selectedOption: PropTypes.string,
  snapShotData: PropTypes.object
};

const mapStateToProps = (state) => ({
  selectedYearInfo: state.companyDashboard.selectedYearInfo
});

export default connect(mapStateToProps, null)(CompanyAnalytics);